import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function signInWithGoogle(redirectTo?: string): Promise<void> {
    const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
            redirectTo: window.location.origin + (redirectTo || ""),
            queryParams: {
                access_type: 'offline',
                prompt: 'consent',
            },
        },
    });

    if (error) {
        console.error("Google sign-in error:", error);
        toast.error("Failed to sign in with Google");
        throw error;
    }

    // OAuth flow initiated successfully - the page will redirect to Google
    // Auth state will be handled by the onAuthStateChange listener in useSupabaseContext
}
